(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
/*
 * Sticky header.
 *
 * Positioning is pure CSS (see the "Sticky header" comment in the style block
 * above): #header-group is always position: sticky, offset upward by the
 * height of whatever sits above the nav bar, so the announcement bar scrolls
 * away and the nav bar pins without ever sliding out of view.
 *
 * This script only does three things:
 *   1. measures that offset, plus how much height the nav loses when it
 *      condenses, and hands both to CSS as custom properties;
 *   2. toggles 'ff-header-condensed' on #header-group once the nav has pinned;
 *   3. closes any open dropdown when the header changes size, so a menu never
 *      hangs off the old position.
 *
 * Measurements are redone on resize, after web fonts load and after the page
 * load event, because the announcement bar's height depends on the font and
 * on how its text wraps. The state is also applied immediately on connect, so
 * a page restored mid-scroll (refresh, back button) starts out correct.
 */
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.headerGroup = document.getElementById('header-group');
    if (!this.headerGroup) return;

    this.offset = 0;
    this.ticking = false;
    this.condensed = this.headerGroup.classList.contains('ff-header-condensed');

    this.onScrollHandler = this.onScroll.bind(this);
    this.onResizeHandler = this.onResize.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    window.addEventListener('resize', this.onResizeHandler, { passive: true });
    window.addEventListener('load', this.onResizeHandler, { once: true });

    this.measure();
    this.update();

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        if (!this.isConnected) return;
        this.measure();
        this.update();
      });
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
    window.removeEventListener('resize', this.onResizeHandler);
    window.removeEventListener('load', this.onResizeHandler);
    window.clearTimeout(this.resizeTimer);

    if (!this.headerGroup) return;
    this.headerGroup.classList.remove('ff-header-condensed');
    this.headerGroup.style.removeProperty('--ff-header-offset');
    this.headerGroup.style.removeProperty('--ff-condense-delta');
    document.documentElement.style.removeProperty('--ff-sticky-nav-height');
  }

  onResize() {
    window.clearTimeout(this.resizeTimer);
    this.resizeTimer = window.setTimeout(() => {
      this.measure();
      this.update();
    }, 100);
  }

  measure() {
    const group = this.headerGroup;
    const wasCondensed = group.classList.contains('ff-header-condensed');

    // Transitions off, so both sizes can be read instantly in one pass.
    group.classList.add('ff-header-measuring');

    group.classList.remove('ff-header-condensed');
    const fullHeight = this.offsetHeight;
    // Everything in the group above the nav bar (announcement bar, top bar).
    this.offset = Math.max(0, Math.round(this.getBoundingClientRect().top - group.getBoundingClientRect().top));

    group.classList.add('ff-header-condensed');
    const condensedHeight = this.offsetHeight;

    group.classList.toggle('ff-header-condensed', wasCondensed);
    group.style.setProperty('--ff-header-offset', `${this.offset}px`);
    group.style.setProperty('--ff-condense-delta', `${Math.max(0, fullHeight - condensedHeight)}px`);
    // Used for scroll-padding-top, so in-page anchor links land below the pinned nav.
    document.documentElement.style.setProperty('--ff-sticky-nav-height', `${condensedHeight}px`);

    // Commit the untransitioned layout before transitions are switched back on.
    void group.offsetHeight;
    group.classList.remove('ff-header-measuring');
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    window.requestAnimationFrame(() => {
      this.ticking = false;
      this.update();
    });
  }

  update() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    // An 8px gap between the "condense" and "expand" lines, so a scroll that
    // comes to rest right on the boundary cannot make the header flicker.
    const shouldCondense = this.condensed
      ? scrollTop > this.offset
      : scrollTop > this.offset + 8;

    if (shouldCondense === this.condensed) return;

    this.condensed = shouldCondense;
    this.headerGroup.classList.toggle('ff-header-condensed', shouldCondense);
    this.closeMenuDisclosure();
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.headerGroup.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => {
      if (typeof disclosure.close === 'function') disclosure.close();
    });
  }
}

customElements.define('sticky-header', StickyHeader);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure__list-wrapper'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
